import { Button } from "@/components/ui/button";
import { InputOTPGroup, InputOTPSlot } from "@/components/ui/input-otp";
import { InputOTP } from "@/components/ui/input-otp";
import { Label } from "@/components/ui/label";
// @ts-expect-error -- untyped module
import mfaSendOtp from "@/assets/mfa-send-otp.svg";
// import {  MfaViewState } from "@/pages/containers/mfa-container";
import { useContext } from "react";
import { useMMfaSetupOtp, useMMfaSetupStatus } from "@/hooks/use-mfa";
import useUserInfo from "@/hooks/use-user-info";
import useAuth from "@/context/auth-provider";
import { useForm } from "@tanstack/react-form";
import { resetPasswordSchema } from "@/lib/form-schema";
import { MFAContext, MfaViewState } from "@/context/mfa-provider";
import { STORAGE_KEY } from "@/constants";

const VerifyOTP = () => {
  const { setViewState, signature, email } = useContext(MFAContext);
  const { authData } = useAuth();
  const userInfo = useUserInfo();
  const mfaVerifyOtpQuery = useMMfaSetupStatus();
  const mfaSetupOtpQuery = useMMfaSetupOtp();

  const handleResendOtp = () => {
    mfaSetupOtpQuery.mutate({
      divisionId: userInfo.divisionId,
      groupId: userInfo.groupId,
      loginGroupId: userInfo.loginGroupId,
      username: userInfo.username,
      accessToken: authData?.user?.access_token,
      email,
    });
  };

  const form = useForm({
    defaultValues: {
      enteredOTP: "",
    },
    onSubmit: ({ value }) => {
      mfaVerifyOtpQuery.mutate(
        {
          divisionId: userInfo.divisionId,
          enteredOTP: value.enteredOTP,
          groupId: userInfo.groupId,
          loginGroupId: userInfo.loginGroupId,
          username: userInfo.username,
          accessToken: authData?.user?.access_token,
          signature: signature!,
        },
        {
          onSuccess: (response) => {
            const storedAuthData = sessionStorage.getItem(
              STORAGE_KEY.AUTH_DATA,
            );
            if (storedAuthData && response.success) {
              const authData = JSON.parse(storedAuthData);
              const updatedAuthData = {
                ...authData,
                is_mfa_enabled: true,
                user: {
                  ...authData.user,
                  is_mfa_enabled: true,
                },
              };
              sessionStorage.setItem(
                STORAGE_KEY.AUTH_DATA,
                JSON.stringify(updatedAuthData),
              );
              setViewState(MfaViewState.SUCCESS);
            } else {
              setViewState(MfaViewState.COMPLETE);
            }
          },
        },
      );
    },
  });

  return (
    <form
      className="flex flex-col justify-between gap-8 text-center sm:w-auto lg:w-[260px]"
      onSubmit={(e) => {
        e.preventDefault();
        e.stopPropagation();
        form.handleSubmit();
      }}
    >
      <div className="grid grid-cols-1 place-items-center gap-6">
        <img src={mfaSendOtp} className="size-20" alt="" />
        <Label className="text-lg font-bold">Verify OTP</Label>
        <div className="flex flex-col gap-1 text-center">
          <Label className="text-sm/6">
            Please enter the OTP sent to your email
          </Label>
          <Label className="font-bold">{userInfo.email}</Label>
        </div>
        <div className="flex gap-2">
          <form.Field
            name="enteredOTP"
            validators={{
              onChange: ({ value }) => {
                const result = resetPasswordSchema.shape.otp.safeParse(value);
                return result.success
                  ? undefined
                  : result.error.errors[0].message;
              },
            }}
          >
            {(field) => (
              <InputOTP
                maxLength={6}
                value={field.state.value}
                onChange={(val) => field.handleChange(val)}
                onBlur={() => field.handleBlur()}
              >
                <InputOTPGroup>
                  <InputOTPSlot index={0} />
                  <InputOTPSlot index={1} />
                  <InputOTPSlot index={2} />
                  <InputOTPSlot index={3} />
                  <InputOTPSlot index={4} />
                  <InputOTPSlot index={5} />
                </InputOTPGroup>
              </InputOTP>
            )}
          </form.Field>
        </div>
        <div className="flex items-center text-center">
          <Label>Don&apos;t Receive OTP?</Label>
          <Button
            variant="link"
            type="button"
            className="h-6 hover:underline"
            onClick={handleResendOtp}
          >
            Resend OTP
          </Button>
        </div>
      </div>
      <div className="flex justify-center gap-4">
        <Button type="submit" className="w-32 rounded-sm">
          Verify OTP
        </Button>
      </div>
    </form>
  );
};

export default VerifyOTP;
